/* global Messi */

/**
 * load texts before any further action
 */
$.i81n.init().done(function() {

'use strict';

	console.log('common.js - init');

	// process js loader queue
	if ($.m_q && typeof $.m_q !== 'undefined' && typeof $.m_q.push === 'function') {

		var qDoneCnt = $.m_q.length;
		// load scripts
		for (var i = 0; i < $.m_q.length; i++) {
			//console.log('load: ' + $.m_q[i] + ' -');
			$.cachedScript($.m_q[i]).done(function() {
				//console.log('- loaded: ' + this.url);

				if (--qDoneCnt === 0) {
					$(document).trigger('moreJS:ready');
					$.m_q = null;
					console.log('- scripts loaded -');
					initMain();
				}
			}).fail(function(jqXHR, textStatus, errorThrown) {
				console.log('! loading failed: ' + this.url, '|', textStatus, ' - ', errorThrown);
			});
		}
	} else {
		$(document).trigger('moreJS:ready');
		initMain();
	}

	/**
	 * Scrolls the given element into the viewport
	 * 
	 * @param {jQuery} $elem
	 */
	$.scrollFocusedIntoView = function ($elem) {
		if ($elem === null) {
			$elem = $(this);
		}
console.log('$.scrollFocusedIntoView()', $elem);
		var $pagehead = $('#pagehead');
		var pageheadPos = $pagehead.offset().top + $pagehead.height() + 5;
		var focusPos = $elem.offset().top;

		if (pageheadPos < $elem.offset().top) {
			$(document).scrollTop(parseInt(focusPos - $pagehead.height() - 5));
		}

	};

	/**
	 * main initialization
	 * @returns {undefined}
	 */
	function initMain() {

		/**
		 * find the element which should get the focus
		 * @returns {undefined}
		 */
		function initFocusElem() {
//			$('a').not('#pagehead a').on('focus', function(){
//				$.scrollFocusedIntoView($(this));
//			});

			// set the focus to the active menu element
			var $focusElem = $('input[autofocus]');
			if ($focusElem.length < 1) {
				$focusElem = $('#mainmenu li.active a');

				// for entrylists set focus to the 1st <a>.
				// for webshop set the focus to the 1st article if available.
				// Otherwise set focus to the active catalogue knot.
				var $preferedFocusElems = $('.entrypreview a, .eventpreview a, a.ws-article, .ws-article a').first();
				if ($('a.ws-activeknot').length > 0) {

					if ($preferedFocusElems.closest('.ws-article').length === 0 ){
						$focusElem = $('a.ws-activeknot').first();
					} else {
						$focusElem = $preferedFocusElems.first();
					}
				} else {
					$focusElem = $preferedFocusElems.first();
				}
			}

			// set the focus to the 1st contact form input
			var $contactFormInput = $('#contactform :input').first();
			if ($contactFormInput.length > 0) {
				$focusElem = $contactFormInput;
			}
			if ($('article.searcharticle').length > 0) {
				var $removeAutoFocus = $('input[autofocus]');
				if ($removeAutoFocus.length > 0) {
					$removeAutoFocus.removeAttr('autofocus');
				}
				$focusElem = $('article.searcharticle').first().find('a').first();
			}

			$focusElem.focus();
		}
		
		/**
		 * Sets the consent cookie 'cc' and closes the cookie consent box.
		 */
		function setConsentCookie(){
			$.cookieHelper.setCookie('cc', '1', 315360000000);
			$('#cookieinfo').remove();
		}
		
		/**
		 * Removes scripts tied to non-permitted cookies.
		 * !! The scripts to be removed must have a class "script_xx",
		 * !! where xx is the cookie name that the scrpit is tied to.
		 * 
		 * @param {jQuery object || null} $cookieList
		 */
		function removeExternalScripts($cookieList){
			$cookieList.each(function(){
				let cookieName = $(this).attr(name);
				
				$('.script_' + cookieName).remove();
			});
		}
		
		function setCookieFormHandlers(){
			/**
			 * set cookie with allowed cookie data
			 */
			$('#cookie_allowselected, #cookie_allowall, #cookie_denyall').on('click', function () {
				let $cookies = $('input[id^="cookie_"]').not('#cookie_essential');
				let $checked = $('input[id^="cookie_"]:checked').not('#cookie_essential');
				let cookieData = {};
				let pressedButtonId = $(this).attr('id');
				let $deniedCookies;
				
				switch(pressedButtonId){
					case 'cookie_allowall':
						$deniedCookies = null;
						break;
					case 'ccokie_allowselected':
						$deniedCookies = $('input[id^="cookie_"]:not(:checked)');
						break;
					case 'cookie_denyall':
						$deniedCookies = $('input[id^="cookie_"]').not('#cookie_essential');
						break;
				}
				
				// remove functional cookies from matched set before looping through the rest of the set
				$cookies.each(function () {
					if(pressedButtonId === 'cookie_allowall'
					|| (pressedButtonId === 'cookie_allowselected' && $checked.is($(this)))){
						cookieData[$(this).attr('name')] = 1;
					}else{
						cookieData[$(this).attr('name')] = 0;
					}
				});

				$.cookieHelper.setCookie('ec', btoa(JSON.stringify(cookieData)), 315360000000);

				setConsentCookie();
				$('#cookieconsent').trigger('close');
				
				if($deniedCookies !== null){
					removeExternalScripts($deniedCookies);	
				}
			});

			/**
			 * check cookie consent msg
			 * set cookie to indicate that settigns were saved
			 */
//			$('#cookie_denyall').on('click', function () {
//				let $deniedCookies = $('input[id^="cookie_"]:not(#cookie_essential)');
//				
//				// set empty ec cookie. this is used to determine whether the user actively made a choice
//				$.cookieHelper.setCookie('ec', btoa(JSON.stringify({})), 315360000000);
//				
//				setConsentCookie();
//				$('#cookieconsent').trigger('close');
//				
//				removeExternalScripts($deniedCookies);
//			});
		}
		
		function buildCookieConsentForm(tplMarkup = null){
			let $lb = $('<div id="cookieconsent" />');
			let $cookieTpl;
					
			if(typeof tplMarkup === 'string' && tplMarkup.length > 0){
				$cookieTpl = $($(tplMarkup).text());
			}else{
				$cookieTpl = $($('#cookieinfo_tpl').text());
			}

			$.loadLightboxJs(function () {
				$lb.lightbox_me_start($cookieTpl, {
					centered: true,
					closeClick: false,
					closeEsc: false,
					onLoad: setCookieFormHandlers,
					showOverlay: false
				}, false, false);
			});
		}
		
		
		console.log('common.js - initMain');

		// load easing effects
		$.cachedScript('/js/jquery.easing.min.js').done(function() {
			
			if($('#cookieinfo_tpl').length){
				buildCookieConsentForm();
			}
			
			$('.cookieconsentlink').on('click', function(e){
				e.preventDefault();
				
				if($('#cookieconsent').length === 0){
					$.ajax({
						url: '/content/cookieconsent',
						type: 'GET',
						dataType: 'json',
						success: function(result){
							buildCookieConsentForm(result);
						}
					});
				}
			});
			
			/**
			 * init style switche elements
			 */
			$.cssSwitcher.init();

			/**
			 * show message box 
			 */
			$('#page-init-notify').initPageInfoMessage();
			/**
			 * initialize click handler for #contactus links
			 */
			$('#contactus,a[id^="contactus-"],a[href^="/contactform.php"]').filter(function() { return $(this).attr('href').match(/[?&]lang=/) === null; }).each(function(e) {
				var getParams = '';

				if ($('#contactform').length < 1) {
					// use the title to initialize the message text of the contactform
					var checkParams = ['kbid=', 'txt='];
					getParams = $(this).attr('title');

					if (getParams) {
						getParams = '&txt=' + encodeURIComponent(getParams);
					} else {
						getParams = '';
					}
					var queries = $(this).attr('href');
					queries = queries.substring(queries.indexOf('?')+1).split('&');
					$.each(queries, function(idx, param) {
						$.each(checkParams, function(cidx, cparam) {
							if (cparam === param.substr(0, cparam.length)) {
								getParams += '&' + param;
							}
						});
					});
					getParams += `&data=${ encodeURIComponent(location.href)}`;
				}
						
				$(this).attr('href', `/contactform.php?lang=${$.cookieHelper.getCookie('mlng') + getParams}`);
			});

			// initialize the toolbar
			if ($('.cmsloggedin, .wsloggedin').length > 0) {
				$.userToolbar();
			} else {
				$.loginToolbar();
			}

			/////////////////////////////////////////////////////////////////////
			// handle invalid images and check video tags
			// Animate click handler for clickable elements
			/////////////////////////////////////////////////////////////////////
			$.commonElementInit();
			
			// check if the session should stay active
			if ($.morejs_options.keepSessionAliveConfig.enabled === true) {
				setInterval(function() {
					$.ajax({
						type: 'POST',
						cache: true,
						url: '/index.php',
						data: 'lt=1',
						success: function(){
							// console.log('keep alive');
						}

					});
				}, 600000);
			}

			// history state saving
			$(window).on('beforeunload.histstate', function () {
				var scrollPos = $(window).scrollTop();
				if (scrollPos > 0) {
					var historyState = (history.state || {});
					historyState.windowScrollPos = scrollPos;
					history.replaceState(historyState, document.title);
				}
			});

			initFocusElem();

			$(window).scrollTop((history.state && history.state.windowScrollPos) ? history.state.windowScrollPos : 0);

			$(document).trigger('main:ready');
			
			$.installResizeHanlder();

			// trigger resize to enable needed event handlers and do layout changes
			setTimeout(function () {
				$(window).trigger('resize');
			}, 300);
		});
	}

});
